var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.75,
    height: 25.55,
    viewBox: "0 0 24.75 25.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5d9cec;}.b{opacity:0.3;}.c{fill:#fff;}.d{opacity:0.2;}.e{fill:#5cd79e;}.f{opacity:0.4;}.g{opacity:0.5;}.h{fill:#eac6bb;}.i{fill:#656d78;}.j{fill:#3a3847;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.994 16.967)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M86.768,345.976a1.6,1.6,0,0,1-1.6,1.6H69.6a1.6,1.6,0,0,1-1.6-1.6V341.6a1.6,1.6,0,0,1,1.6-1.6H85.172a1.6,1.6,0,0,1,1.6,1.6Z",
    transform: "translate(-68.006 -340.005)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2.994 16.967)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M68.8,345.976V341.6a1.6,1.6,0,0,1,1.6-1.6h-.8a1.6,1.6,0,0,0-1.6,1.6v4.375a1.6,1.6,0,0,0,1.6,1.6h.8A1.6,1.6,0,0,1,68.8,345.976Z",
    transform: "translate(-68.005 -340.005)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(19.381 16.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398,345.976V341.6a1.6,1.6,0,0,0-1.6-1.6h.8a1.6,1.6,0,0,1,1.6,1.6v4.375a1.6,1.6,0,0,1-1.6,1.6h-.8A1.6,1.6,0,0,0,398,345.976Z",
    transform: "translate(-396.402 -340.005)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.2 18.276)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M33.963,368.123A38.031,38.031,0,0,1,30.37,366.6c-.235-.124-.459-.243-.659-.363a5.8,5.8,0,0,1-5.529,3.082c-4.2,0-5.489-2.966-5.529-3.082-.2.12-.423.24-.659.363a38.025,38.025,0,0,1-3.593,1.521c-1.6.595-2.4,1.2-2.4,2.794v2.4H36.358v-2.4C36.358,369.321,35.56,368.718,33.963,368.123Z",
    transform: "translate(-12.007 -366.239)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(17.516 18.276)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.245,366.6c-.236-.124-.459-.243-.659-.363a5.875,5.875,0,0,1-.379.66c.117.068.6.269.722.333A3.861,3.861,0,0,0,360.245,366.6Z",
    transform: "translate(-359.207 -366.239)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.024,379.4l-.007,0C359.011,379.411,359.015,379.409,359.024,379.4Z",
    transform: "translate(-359.014 -379.395)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(6.188 18.276)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M132,366.6c.235-.124.459-.243.659-.363a5.887,5.887,0,0,0,.379.66c-.117.068-.6.269-.722.333A3.858,3.858,0,0,1,132,366.6Z",
    transform: "translate(-132.004 -366.239)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.037 0.657)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M152.792,379.4l.007,0C152.8,379.411,152.8,379.409,152.792,379.4Z",
    transform: "translate(-152.792 -379.395)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(0.2 18.639)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.805,378.235c0-1.6.8-2.2,2.4-2.794.74-.274,2.01-.766,3.112-1.286a3.871,3.871,0,0,1-.317-.634,38.066,38.066,0,0,1-3.593,1.521c-1.6.595-2.4,1.2-2.4,2.794v2.4h.8Z",
    transform: "translate(-12.007 -373.52)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(18.245 18.639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.144,378.235c0-1.6-.8-2.2-2.4-2.794-.739-.274-2.01-.766-3.112-1.286a3.874,3.874,0,0,0,.317-.634,38.067,38.067,0,0,0,3.593,1.521c1.6.595,2.4,1.2,2.4,2.794v2.4h-.8Z",
    transform: "translate(-373.637 -373.52)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.846 15.769)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M150.736,318.8c1.361,0,3.158-1.1,4.591-2.794v1.6c0,.255.375.575.938.91a5.8,5.8,0,0,1-5.529,3.082c-4.2,0-5.489-2.966-5.529-3.082.563-.335.938-.655.938-.91v-1.6C147.578,317.7,149.374,318.8,150.736,318.8Z",
    transform: "translate(-145.207 -316.006)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.389 5.779)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M129.944,119.015l.032.8a9.562,9.562,0,0,1-2.4,5.988c-1.433,1.693-3.229,2.794-4.591,2.794s-3.158-1.1-4.591-2.794a9.561,9.561,0,0,1-2.4-5.988V119.1c2.247-1.18,7.354-3.535,11.976-3.263Z",
    transform: "translate(-116.004 -115.811)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(11.976 7.676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.353,155.13l-.8-1.307.032,2.105a9.562,9.562,0,0,1-2.4,5.988A7.583,7.583,0,0,1,248,164.678a2.9,2.9,0,0,0,.4.032c1.361,0,3.158-1.1,4.591-2.794a9.562,9.562,0,0,0,2.4-5.988Z",
    transform: "translate(-248 -153.823)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.389 8.658)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M119.2,180.607a9.562,9.562,0,0,1-2.4-5.988V173.5l-.8.406v.717a9.561,9.561,0,0,0,2.4,5.988c1.433,1.693,3.229,2.794,4.591,2.794a2.9,2.9,0,0,0,.4-.032A7.582,7.582,0,0,1,119.2,180.607Z",
    transform: "translate(-116.003 -173.495)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(7.784 15.769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.594,318.8c-1.361,0-3.158-1.1-4.591-2.794v.4c1.433,1.693,3.229,2.794,4.591,2.794s3.158-1.1,4.591-2.794v-.4C171.751,317.7,169.955,318.8,168.594,318.8Z",
    transform: "translate(-164.003 -316.006)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.192 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M94.8,5.213c-.02.008,13.33-5.657,12.343,7.585l-1.964-3.182c-6.028-.355-12.962,3.8-13.17,3.924l0,0c0-5.988,3.908-7.665,3.908-7.665Z",
    transform: "translate(-92.005 -4.015)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(12.357 0.201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.641,4.03c3.132.116,6.273,1.692,6.225,7.564l.747,1.211C263.166,5.385,259.217,3.9,255.641,4.03Z",
    transform: "translate(-255.641 -4.023)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(4.192 0.201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M96.712,5.892,95.6,5.225a17.207,17.207,0,0,1,5.371-1.19,16.589,16.589,0,0,0-6.17,1.19l1.114.667S92,7.569,92,13.557l0,0c.04-.023.326-.195.8-.453C93.006,7.484,96.712,5.892,96.712,5.892Z",
    transform: "translate(-92.005 -4.028)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(6.997 16.168)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M148.67,326.671c.529-.345,1.133-.842,1.133-1.068v-.75a10.879,10.879,0,0,1-.8-.846v1.2c0,.255-.835.847-.786.816A4.883,4.883,0,0,0,148.67,326.671Z",
    transform: "translate(-148.218 -324.006)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(6.846 16.168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.107,326.018l-.006.009c-.094-.072-.77-.573-.77-.8v-1.216a10.887,10.887,0,0,1-.8.848v.768c0,.222.587.708,1.11,1.052a6.089,6.089,0,0,1-4.908,2.123,5.855,5.855,0,0,1-5.376-2.777c-.049.032-.1.063-.152.094.04.116,1.326,3.082,5.529,3.082a5.8,5.8,0,0,0,5.529-3.082C156.209,326.082,156.158,326.05,156.107,326.018Z",
    transform: "translate(-145.206 -324.007)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.792 18.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M86,364l-2,.8v6.387h2Z",
    transform: "translate(-84.005 -364.004)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(5.389 18.164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,364.163v7.026h.4V364Z",
    transform: "translate(-116.004 -364.004)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(3.792 18.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M86,364.163V364l-2,.8v6.387h.4V364.8Z",
    transform: "translate(-84.005 -364.004)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.962 18.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M388,364l2,.8v6.387h-2Z",
    transform: "translate(-387.996 -364.004)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(18.962 18.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M388.4,364.163v7.026H388V364Z",
    transform: "translate(-387.996 -364.004)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(18.962 18.164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388,364.163V364l2,.8v6.387h-.4V364.8Z",
    transform: "translate(-387.996 -364.004)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.582)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.988 7.585)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M128.2,345.675a.2.2,0,0,1-.091-.377c1.416-.722,1.488-1.038,1.488-1.094a.2.2,0,0,1,.4,0c0,.27-.194.678-1.706,1.449A.2.2,0,0,1,128.2,345.675Z",
    transform: "translate(-128.003 -344.004)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.074)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M32.558,399.783H8.207a.2.2,0,0,1-.2-.2v-2.4c0-1.713.887-2.37,2.525-2.981.223-.083.494-.186.8-.3a.2.2,0,0,1,.145.372c-.3.118-.577.222-.8.305-1.535.573-2.265,1.11-2.265,2.608v2.2H32.358v-2.2c0-1.5-.731-2.034-2.265-2.608-.225-.084-.5-.187-.8-.306a.2.2,0,1,1,.145-.372c.3.117.573.22.8.3,1.637.612,2.525,1.268,2.525,2.981v2.4A.2.2,0,0,1,32.558,399.783Z",
    transform: "translate(-8.007 -393.889)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.766 7.585)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M345.794,345.675a.2.2,0,0,1-.091-.022c-1.512-.771-1.706-1.18-1.706-1.449a.2.2,0,0,1,.4,0c0,.056.072.372,1.488,1.094a.2.2,0,0,1-.091.377Z",
    transform: "translate(-343.998 -344.004)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.19)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M119.189,201.192c-2.707,0-7.185-4.2-7.185-8.982a.2.2,0,1,1,.4,0c0,4.426,4.233,8.583,6.786,8.583s6.787-4.157,6.787-8.583a.2.2,0,1,1,.4,0C126.375,196.993,121.9,201.192,119.189,201.192Z",
    transform: "translate(-112.004 -192.01)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.585 5.988)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M160.2,314a.2.2,0,0,1-.2-.2v-1.6a.2.2,0,1,1,.4,0v1.6A.2.2,0,0,1,160.2,314Z",
    transform: "translate(-160.003 -312.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.766 5.988)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M344.2,314a.2.2,0,0,1-.2-.2v-1.6a.2.2,0,1,1,.4,0v1.6A.2.2,0,0,1,344.2,314Z",
    transform: "translate(-343.998 -312.006)"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.992)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M88.206,9.929a.2.2,0,0,1-.2-.2c0-5.02,2.746-7.1,3.7-7.674L90.9,1.569a.2.2,0,0,1-.071-.271A15.046,15.046,0,0,1,96.779,0,6.537,6.537,0,0,1,101.8,1.875c1.4,1.506,1.985,3.9,1.745,7.123a.2.2,0,0,1-.369.09l-1.908-3.093C95.3,5.7,88.376,9.859,88.309,9.9A.2.2,0,0,1,88.206,9.929Zm3.247-8.492.763.456a.2.2,0,0,1-.023.355A5.8,5.8,0,0,0,90.3,3.8,8.867,8.867,0,0,0,88.41,9.38c1.433-.812,7.6-4.1,12.981-3.777a.2.2,0,0,1,.158.094l1.631,2.643c.115-2.788-.448-4.869-1.676-6.193A6.157,6.157,0,0,0,96.779.4,16.529,16.529,0,0,0,91.453,1.436Z",
    transform: "translate(-88.006)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.647 18.077)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M146.933,365.73c-4.4,0-5.706-3.183-5.717-3.215a.2.2,0,1,1,.377-.131c.011.028,1.21,2.948,5.34,2.948a5.605,5.605,0,0,0,5.342-2.952.2.2,0,0,1,.258-.114.2.2,0,0,1,.116.255A6.039,6.039,0,0,1,146.933,365.73Z",
    transform: "translate(-141.205 -362.249)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.589 17.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M120.2,367.228a.2.2,0,0,1-.2-.2V360.2a.2.2,0,0,1,.4,0v6.824A.2.2,0,0,1,120.2,367.228Z",
    transform: "translate(-120.004 -360.005)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.593 17.964)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M80.206,361.191a.2.2,0,0,1-.074-.385l2-.8a.2.2,0,0,1,.148.371l-2,.8A.2.2,0,0,1,80.206,361.191Z",
    transform: "translate(-80.006 -359.993)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.593 18.763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M80.2,382.391a.2.2,0,0,1-.2-.2V376.2a.2.2,0,1,1,.4,0v5.988A.2.2,0,0,1,80.2,382.391Z",
    transform: "translate(-80.005 -376.004)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.762 17.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M384.2,367.228a.2.2,0,0,1-.2-.2V360.2a.2.2,0,0,1,.4,0v6.824A.2.2,0,0,1,384.2,367.228Z",
    transform: "translate(-383.996 -360.005)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.762 17.964)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M386.193,361.2a.2.2,0,0,1-.074-.014l-2-.8a.2.2,0,0,1,.148-.371l2,.8a.2.2,0,0,1-.074.385Z",
    transform: "translate(-383.997 -359.997)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.758 18.763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M424.194,382.391a.2.2,0,0,1-.2-.2V376.2a.2.2,0,1,1,.4,0v5.988A.2.2,0,0,1,424.194,382.391Z",
    transform: "translate(-423.994 -376.004)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.391 16.767)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M98.6,336.405H96.2a.2.2,0,1,1,0-.4h2.4a.2.2,0,1,1,0,.4Z",
    transform: "translate(-96.004 -336.006)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.794 18.364)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M64.206,369.152a.2.2,0,0,1-.2-.2V368.2a.2.2,0,1,1,.4,0v.749A.2.2,0,0,1,64.206,369.152Z",
    transform: "translate(-64.006 -368.004)"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.794 16.767)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M64.206,338a.2.2,0,0,1-.2-.2,1.8,1.8,0,0,1,1.8-1.8.2.2,0,1,1,0,.4,1.4,1.4,0,0,0-1.4,1.4A.2.2,0,0,1,64.206,338Z",
    transform: "translate(-64.006 -336.006)"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.565 16.767)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M362.591,336.405h-2.4a.2.2,0,1,1,0-.4h2.4a.2.2,0,1,1,0,.4Z",
    transform: "translate(-359.996 -336.006)"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.557 18.364)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M440.194,369.152a.2.2,0,0,1-.2-.2V368.2a.2.2,0,1,1,.4,0v.749A.2.2,0,0,1,440.194,369.152Z",
    transform: "translate(-439.994 -368.004)"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.96 16.767)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M409.792,338a.2.2,0,0,1-.2-.2,1.4,1.4,0,0,0-1.4-1.4.2.2,0,1,1,0-.4,1.8,1.8,0,0,1,1.8,1.8A.2.2,0,0,1,409.792,338Z",
    transform: "translate(-407.996 -336.006)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentAvatar);
export default __webpack_public_path__ + "static/media/student_avatar.4732c52968ec654f4ece6b85cc9a7b34.svg";
export { ForwardRef as ReactComponent };